__turbopack_context__.v({
  "footer": "MinimalFooter-module-scss-module__Llaxvq__footer",
  "footer__cookie-button": "MinimalFooter-module-scss-module__Llaxvq__footer__cookie-button",
  "footer__copyright": "MinimalFooter-module-scss-module__Llaxvq__footer__copyright",
  "footer__link": "MinimalFooter-module-scss-module__Llaxvq__footer__link",
  "footer__links": "MinimalFooter-module-scss-module__Llaxvq__footer__links",
});
